// import { Button } from '@renderer/components/ui/button'
// import QuizPage from './QuizPage'
import RATPCard from '@renderer/components/RATPCard'
import { BgTwColor, TextTwColor } from '@renderer/@types/types'
import { t } from 'i18next'
import { useQuiz } from '@renderer/lib/useQuiz'

const QuizSelection = () => {
  const { setCurrentQuiz } = useQuiz()
  const selectQuiz = (quiz: string) => {
    if (quiz === 'quiz1') {
      setCurrentQuiz('quiz1')
    } else if (quiz === 'quizGroup') {
      setCurrentQuiz('quizGroup')
    } else if (quiz === 'quizGroupUMOP') {
      setCurrentQuiz('quizGroupUMOP')
    } else if (quiz === 'quizInnovation') {
      setCurrentQuiz('quizInnovation')
    } else if (quiz === 'quizTransport') {
      setCurrentQuiz('quizTransport')
    } else if (quiz === 'quizSolutionVille') {
      setCurrentQuiz('quizSolutionVille')
    } else if (quiz === 'quizRatpDev') {
      setCurrentQuiz('quizRatpDev')
    } else if (quiz === 'quizMetroMusic') {
      setCurrentQuiz('quizMetroMusic')
    } else if (quiz === 'quizJEP') {
      setCurrentQuiz('quizJEP')
    }
  }
  return (
    <div className="grid grid-cols-1 w-full h-full items-center justify-center gap-8 landscape:gap-18 p-6 landscape:p-12n">
      <div className="w-full h-full flex items-center justify-center">
        <div className="w-full aspect-[2/3] max-w-64">
          <RATPCard
            title={t(`quizGroupUMOP.title` as any)}
            description={t(`quizGroupUMOP.description` as any)}
            image={'quizGroupUMOP.webp'}
            bgColor={BgTwColor.WHITE}
            textColor={TextTwColor.PRIMARY}
            shadowColor={BgTwColor.RATP_ROSE_CLAIR}
            rounded={false}
            onClick={() => selectQuiz('quizGroupUMOP')}
            key={'quizGroupUMOP'}
            className="w-full h-full"
          />
        </div>
      </div>
      {/*
      <div className="w-full h-full flex items-center justify-center">
        <div className="w-full aspect-[2/3] max-w-64">
          <RATPCard 
            title={t(`quizGroup.title` as any)}
            description={t(`quizGroup.description` as any)}
            image={'quizGroup.webp'}
            bgColor={BgTwColor.WHITE}
            textColor={TextTwColor.PRIMARY}
            shadowColor={BgTwColor.RATP_ROSE_CLAIR}
            rounded={false}
            onClick={() => selectQuiz('quizGroup')}
            key={'quizGroup'}
            className="w-full h-full"
          />
        </div>
      </div>
      <div className="w-full h-full flex items-center justify-center">
        <div className="w-full aspect-[2/3] max-w-64">
          <RATPCard
            title={t(`quizTransport.title` as any)}
            description={t(`quizTransport.description` as any)}
            image={'quizTransport.webp'}
            bgColor={BgTwColor.PRIMARY}
            textColor={TextTwColor.WHITE}
            shadowColor={BgTwColor.RATP_OR}
            rounded={false}
            onClick={() => selectQuiz('quizTransport')}
            key={'quizTransport'}
            className="w-full h-full"
          />
        </div>
      </div>
*/}
      {/* <div className="w-full h-full flex items-center justify-center">
        <div className="w-full aspect-[2/3] max-w-64">
          <RATPCard
            title={t(`quizSolutionVille.title` as any)}
            description={t(`quizSolutionVille.description` as any)}
            image={'quizSolutionVille.webp'}
            bgColor={BgTwColor.WHITE}
            textColor={TextTwColor.PRIMARY}
            shadowColor={BgTwColor.RATP_FRAMBOISE}
            rounded={false}
            onClick={() => selectQuiz('quizSolutionVille')}
            key={'quizSolutionVille'}
            className="w-full h-full"
          />
        </div>
      </div>  */}
      {/* 
      <div className="w-full h-full flex items-center justify-center">
        <div className="w-full aspect-[2/3] max-w-64">
          <RATPCard
            title={t(`quizInnovation.title` as any)}
            description={t(`quizInnovation.description` as any)}
            image={'quizInnovation.webp'}
            bgColor={BgTwColor.WHITE}
            textColor={TextTwColor.PRIMARY}
            shadowColor={BgTwColor.RATP_ORANGE_FONCE}
            rounded={false}
            onClick={() => selectQuiz('quizInnovation')}
            key={'quizInnovation'}
            className="w-full h-full"
          />
        </div>
      </div>
*/}
      {/*
      <div className="w-full h-full flex items-center justify-center">
        <div className="w-full aspect-[2/3] max-w-64">
          <RATPCard
            title={t(`quizRatpDev.title` as any)}
            description={t(`quizRatpDev.description` as any)}
            image={'quizRatpDev.webp'}
            bgColor={BgTwColor.WHITE}
            textColor={TextTwColor.PRIMARY}
            shadowColor={BgTwColor.RATP_ORANGE_FONCE}
            rounded={false}
            onClick={() => selectQuiz('quizRatpDev')}
            key={'quizRatpDev'}
            className="w-full h-full"
          />
        </div>
      </div>
*/}
{/* 
      <div className="w-full h-full flex items-center justify-center">
        <div className="w-full aspect-[2/3] max-w-64">
          <RATPCard
            title={t(`quizMetroMusic.title` as any)}
            description={t(`quizMetroMusic.description` as any)}
            image={'quizMetroMusic.webp'}
            bgColor={BgTwColor.WHITE}
            textColor={TextTwColor.PRIMARY}
            shadowColor={BgTwColor.RATP_ORANGE_FONCE}
            rounded={false}
            onClick={() => selectQuiz('quizMetroMusic')}
            key={'quizMetroMusic'}
            className="w-full h-full"
          />
        </div>
      </div> 

      <div className="w-full h-full flex items-center justify-center">
        <div className="w-full aspect-[2/3] max-w-64">
          <RATPCard
            title={t(`quizJEP.title` as any)}
            description={t(`quizJEP.description` as any)}
            image={'quizJEP.webp'}
            bgColor={BgTwColor.WHITE}
            textColor={TextTwColor.PRIMARY}
            shadowColor={BgTwColor.RATP_ORANGE_FONCE}
            rounded={false}
            onClick={() => selectQuiz('quizJEP')}
            key={'quizJEP'}
            className="w-full h-full"
          />
        </div>
      </div>*/}
    </div>    
  )
}

export default QuizSelection
